module.exports = __webpack_public_path__ + "img/w3_minimize_light.0d53c678.png";